import { render, staticRenderFns } from "./userBar.vue?vue&type=template&id=27a4a5a0&scoped=true&"
import script from "./userBar.vue?vue&type=script&lang=js&"
export * from "./userBar.vue?vue&type=script&lang=js&"
import style0 from "./userBar.vue?vue&type=style&index=0&id=27a4a5a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a4a5a0",
  null
  
)

export default component.exports